module.exports = __webpack_public_path__ + "assets/img/Eimele-2-Landing-Page-w720.bca9e916.webp";